import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { urlHelper } from 'src/app/helpers';
import { axiosc } from 'src/app/utils';
import { queryTypes, servicesTaraflarTypes } from 'src/types';

export const taraflarLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesTaraflarTypes.TaraflarLookupDataType): AxiosPromise<servicesTaraflarTypes.TaraflarLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.taraflar), {
    blockSpinner,
  });
};
